/**
 * @generated SignedSource<<2befb4049b970799f899524aea56fbb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AnalysisForecastAccountsViewQuery$variables = Record<PropertyKey, never>;
export type AnalysisForecastAccountsViewQuery$data = {
  readonly bankAccounts: ReadonlyArray<{
    readonly bankAccountIdentifier: string;
    readonly coveredUntil: any | null | undefined;
    readonly currentBalance: number;
    readonly id: string;
    readonly lastUpload: {
      readonly bookingCount: number;
      readonly firstBookingDate: any;
      readonly lastBookingDate: any;
      readonly uploadedAt: any;
      readonly uploadedBy: string;
    } | null | undefined;
    readonly name: string;
  }>;
};
export type AnalysisForecastAccountsViewQuery = {
  response: AnalysisForecastAccountsViewQuery$data;
  variables: AnalysisForecastAccountsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "bankAccounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bankAccountIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "coveredUntil",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BankStatementUpload",
        "kind": "LinkedField",
        "name": "lastUpload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBookingDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastBookingDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bookingCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisForecastAccountsViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalysisForecastAccountsViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3a2efa235ef56631a1b2b61cec4408d1",
    "id": null,
    "metadata": {},
    "name": "AnalysisForecastAccountsViewQuery",
    "operationKind": "query",
    "text": "query AnalysisForecastAccountsViewQuery {\n  bankAccounts {\n    id\n    bankAccountIdentifier\n    name\n    currentBalance\n    coveredUntil\n    lastUpload {\n      firstBookingDate\n      lastBookingDate\n      bookingCount\n      uploadedBy\n      uploadedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2ff81120ec6f9267fcbdb34f8a715c4";

export default node;
